// src/store/favoritesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { favoritesAPI } from '../api/favorites.js';

export const getFavorites = createAsyncThunk(
  'favorites/get',
  async (_, { rejectWithValue }) => {
    try {
      const response = await favoritesAPI.getAll();
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to load favorites');
    }
  }
);

export const addToFavorites = createAsyncThunk(
  'favorites/add',
  async (productId, { rejectWithValue, dispatch }) => {
    try {
      await favoritesAPI.add(productId);
      dispatch(getFavorites());
      return productId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to add to favorites');
    }
  }
);

export const removeFromFavorites = createAsyncThunk(
  'favorites/remove',
  async (productId, { rejectWithValue, dispatch }) => {
    try {
      await favoritesAPI.remove(productId);
      dispatch(getFavorites());
      return productId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to remove from favorites');
    }
  }
);

export const checkFavorite = createAsyncThunk(
  'favorites/check',
  async (productId, { rejectWithValue }) => {
    try {
      const response = await favoritesAPI.check(productId);
      return { productId, isFavorite: response.data.data.is_favorite };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to check favorite');
    }
  }
);

const initialState = {
  items: [],
  isLoading: false,
  error: null,
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFavorites.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFavorites.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload || [];
      })
      .addCase(getFavorites.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(addToFavorites.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(removeFromFavorites.fulfilled, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearError } = favoritesSlice.actions;
export default favoritesSlice.reducer;